import styled from "styled-components";

// Colores Corporativos de Colbún
const colors = {
  primary: "#3C6CB1", // Azul
  secondary: "#8CB740", // Verde
  warning: "#E09B2D", // Naranja
  error: "#E74C3C", // Rojo
  background: "#F4F4F4", // Gris claro
  text: "#2C3E50", // Gris oscuro para el texto
};

// Contenedor de la página
export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${colors.background};
`;

// Contenedor de contenido principal
export const ContentWrap = styled.div`
  flex: 1;
  margin-top: 70px; /* Ajustar después de agregar el Navbar */
  padding: 15px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

// Contenedor centrado para mensajes o contenido
export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  max-width: 1000px;
  margin: 0 auto;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

// Estilo para los mensajes de error
export const ErrorMessage = styled.h2`
  font-size: 1.5rem;
  color: ${colors.error}; /* Rojo para mensajes de error */
  text-align: center;
  margin-top: 20px;
  padding: 10px;
  background-color: #f8d7da;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

// Estilo de título
export const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: bold;
  color: ${colors.text}; /* Gris oscuro para el texto */
  text-align: center;
  margin-bottom: 20px;
`;

// Estilo para los enlaces (como los botones)
export const StyledLink = styled.a`
  text-decoration: none;
  color: ${colors.primary}; /* Azul para enlaces */
  &:hover {
    text-decoration: underline;
  }
`;

// Contenedor de los cards
export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  margin-top: 20px;
`;

// Estilo de botón
export const Button = styled.button`
  background-color: ${colors.primary};
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: ${colors.secondary};
  }

  &:active {
    background-color: ${colors.primary};
  }
`;
